<app-garbage-collector-sheduler-settings-form [settings]="settings"></app-garbage-collector-sheduler-settings-form>
<div class="dialog-footer">
    <mat-dialog-actions>
        <button mat-flat-button color="primary" style="width: 100%" (click)="save()" [disabled]="isFormInvalid">Save
            Settings</button>
    </mat-dialog-actions>
</div>